var _defs, _defs2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMika(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 319.4 398",
    style: {
      enableBackground: "new 0 0 319.4 398"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1_00000152972898201262224540000004112446001031644321_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D0E09C"
    },
    cx: 159.7,
    cy: 238.3,
    r: 159.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M319.4,238.3c0-88.2-71.5-259.7-159.7-259.7S0,150.1,0,238.3S71.5,398,159.7,398 S319.4,326.5,319.4,238.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056393616721186267610000008298597568443170955_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056393616721186267610000008298597568443170955_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M217.5,192.6c4.8,10.8,13.2,36.4,29.3,47.4s-41.4,14.7-41.4,14.7l-14.5-52l13.3-21.9 L217.5,192.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M184,37.8c0.5-11.4-14.7-27.2-32.1-29.1c-45-4.9-70.4,32.7-80.4,80.1 c-8.4,39.7,3.1,111.2-33.4,118.8c0,0,0,0.2-0.1,0.5c-1,11.3,16.3,12.1,26.2,6.6c25.3-13.9,32.3-51.4,32.3-51.4 s-11.7,68.3-52.7,75.2c0,0,11,16.9,39.6,22.2c112.6,20.9,84.3-123.4,84.3-123.4L184,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E8F3"
    },
    d: "M285.1,265.9c-5.6-9.8-27.5-20.6-30.3-20.9c-10.1-1-51.7-0.1-55.9-13.6 c-2.5-8-2.4-17.1-1.6-24.4h-54.5c1,6.6,0.8,13.3,0.7,20.1c-0.3,14-11,12.2-13.3,13c-9.1,3-31.3,5.8-45.8,7.4 c-7.9,0.9-29.1,11.1-37,22.8c-8.1,12-7.9,118.6-6.3,143.9h255C297.2,383.5,294.6,282.4,285.1,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M50.6,266.7c-7.2,9.5-8.3,24.9-8.6,27.8c9.1,18.3,24.5,43.1,24.5,43.1c0.2,1,2.3,70.5,2.7,76.6 h9.3C80.7,363.2,50.6,266.7,50.6,266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M269.3,336c0,0,15.5-25,23.3-40.8c0,0-2.5-22.1-8.7-29c-1.4,2.4-30.5,111.5-26.8,148.1h10.8 C268.2,408.4,268.1,345.7,269.3,336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C2D50"
    },
    d: "M262.1,333c10.9-16.5,30.4-51,30.4-51s-10.2-38.4-50.7-39.8c-19.3,15.5-60.5,21.9-76.9,21.8 c-25.2-0.1-53.5-9.3-65.9-20.2c-27.8,2.9-49.8,17.7-57.9,38.2c9.7,19.8,27.8,40.4,32.2,52.3c2.7,15.9,1.4,74.9,1.4,79.9h186.5 C260.9,402.7,260.4,350.3,262.1,333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M86.2,414.3H74.7c0,0-1.6-95.4-2.8-102.3L86.2,414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M249.6,414.3h11.5c0,0,1.1-96.6,1.8-103.3L249.6,414.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E8F3"
    },
    d: "M231.3,244.6c2.2-0.9,4.4-2.2,6.6-3.5c-24.7-3.2-32.1-7.4-33.9-8.6 c-1.9-1.3-3.7-7.4-4.4-14.6c-0.3-3.1-0.8-11-0.9-15.1c-0.9,1.1-55-0.9-57-4h-6.3c0,0,1.9,19.9-1.1,34.2 c-0.6,2.9-18.1,7-29.6,9.4c0.8,0.6,3.8,2.6,4.4,3c9.8,1,18.3,2.1,22.3,1.4c4.9-0.9,13.2-4.6,19.2-7.4 c32.4-14.9,42.6-19.8,42.6-19.8c1.5,13.8,11.7,23,11.2,22.8C212.6,244.5,222.5,244.9,231.3,244.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M180.1,256.8c0,0,3.3-8.4,7.8-9.6c4.5-1.1,46.3-1.4,52.2-2.6c0,0-13.9,3.5-26.8,5 C200.3,251.1,190.2,248.9,180.1,256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCFE0"
    },
    d: "M164,256.7c0,0-3.1-6.5-8.7-8.4c-5.6-1.9-48.3-4.5-56-3.8C99.3,244.6,153.2,250,164,256.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#475C90"
    },
    d: "M109.2,241.3c0,0,24.8,18,59.8,18.6c31.5,0.5,52.9-6.5,65.5-19.5l8.6,1.7 c0,0-17.2,27.6-73.2,26.2c-48.1-1.2-71.3-24.6-71.3-24.6L109.2,241.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015324209619341782500000007776217500897275569_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.5921,
    y1: 395.4613,
    x2: 154.1257,
    y2: 585.8896,
    gradientTransform: "matrix(1 0 0 1 0 -158.4996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#001F47",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1228,
    style: {
      stopColor: "#00224B",
      stopOpacity: 0.1228
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3147,
    style: {
      stopColor: "#052B57",
      stopOpacity: 0.3147
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    style: {
      stopColor: "#153866",
      stopOpacity: 0.5518
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    style: {
      stopColor: "#2B4A78",
      stopOpacity: 0.8222
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B5683"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "url(#SVGID_00000015324209619341782500000007776217500897275569_)",
      enableBackground: "new"
    },
    d: " M95.8,404.2c16.5,3.7,136.8,5.7,144.2,2s13.8-127.8,13.8-127.8H77.7C77.7,278.3,85.9,402,95.8,404.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M226.7,169.9c5,15.9,9.7,37.1,22.6,44.5c0,0-8.9,7.4-20.9-1c-11.9-8.4-19.7-24.9-22-36.3 S226.7,169.9,226.7,169.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M237.5,106.1c11.4,24.1-12.1,44.3-1.3,94.1c4.3,19.9-26.9-33.5-26.9-33.5l17.3-69.8 L237.5,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M211.8,146.6c0,0,10.1-16.8,19.6-13.9c22.8,6.9,0.6,39.2-13.1,40.2c-4.4,0.3-6.9-3.4-6.9-3.4 L211.8,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E87B1"
    },
    d: "M218.5,149.5c5.4-6.2,11.1-4.3,11.5,0.5c0.6,6.2-10.5,18.3-17.2,12.1L218.5,149.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M229.2,137.8c4.4-1,10.1,1.6,11.8,4.8c-0.7-4.4-3.3-9.1-9.9-10.4c-9.7-2-19.3,14.5-19.3,14.5 l-0.4,17.1C214.4,156,220.3,139.9,229.2,137.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M218.3,172.9c5.6-0.4,12.6-6,17.4-12.9c-10,14.1-21.3,6.8-24.3,3.7l-1.9,5.2 C209.5,168.9,213.9,173.2,218.3,172.9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M141.8,187.4c4.2,35.5-2,45.5-2,45.5s-6.9,6.3,22.1,11.4c35.4,6.2,33.8-4.9,33.8-4.9 s-0.7-24.9,2.7-40.6C201.9,183.2,141.8,187.4,141.8,187.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9D6"
    },
    d: "M141.8,187.4c0.4,3.4-10.5-3-10.4,0.2l11.7,20.5c19.4,33.5,52.5,22.1,52.5,22.1l1.9-26.8 c0.2-1.5,0.5-3,0.8-4.5C201.9,183.2,141.8,187.4,141.8,187.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M151.1,1.3c0,0,0.7,0.3,2,0.8s3.1,1.2,5.3,2.2s4.7,2.2,7.4,3.7c1.3,0.8,2.7,1.6,4,2.5 s2.6,2,3.9,3c0.6,0.6,1.3,1.1,1.9,1.7l0.9,0.9c0.3,0.3,0.6,0.6,0.9,0.9c0.6,0.6,1.1,1.3,1.6,1.9c0.5,0.7,1,1.3,1.5,2 c0.9,1.4,1.7,2.7,2.4,4.1c0.3,0.7,0.7,1.3,0.9,2c0.3,0.7,0.6,1.3,0.8,1.9s0.4,1.2,0.6,1.8c0.2,0.6,0.3,1.2,0.5,1.7 c0.3,1.1,0.4,2,0.6,2.8c0.2,1.6,0.3,2.5,0.3,2.5c0.4,2.7-1.5,5.2-4.2,5.5c-2.7,0.4-5.2-1.5-5.5-4.2c0-0.3-0.1-0.6,0-0.9v-0.2 c0,0,0-0.7,0.1-1.9c0-0.6,0-1.3,0-2.1c0-0.4-0.1-0.9-0.1-1.3c0-0.5-0.1-0.9-0.2-1.5c-0.1-0.5-0.2-1-0.3-1.6s-0.3-1.1-0.4-1.7 c-0.3-1.2-0.8-2.4-1.3-3.6c-0.3-0.6-0.6-1.2-0.9-1.8c-0.3-0.6-0.7-1.2-1-1.8c-0.2-0.3-0.4-0.6-0.6-0.9l-0.6-0.9 c-0.4-0.6-0.9-1.2-1.3-1.8c-0.9-1.2-1.9-2.3-3-3.4c-1-1.1-2.1-2.1-3.2-3c-2.2-1.9-4.4-3.5-6.3-4.9c-1.9-1.3-3.6-2.4-4.8-3.1 C151.8,1.8,151.1,1.3,151.1,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M180.9,8.4c0,0,0.3,0.4,0.7,1.1c0.5,0.7,1.1,1.8,1.8,3.1c0.4,0.7,0.7,1.4,1.1,2.2 c0.3,0.8,0.7,1.6,1.1,2.5c0.2,0.4,0.4,0.9,0.5,1.3c0.2,0.5,0.3,0.9,0.5,1.4c0.3,0.9,0.6,1.9,0.9,2.9c0.2,1,0.5,2,0.7,2.9 c0.2,1,0.4,2,0.5,2.9c0.1,0.5,0.1,0.9,0.2,1.4s0.1,0.9,0.1,1.4c0.1,0.9,0.1,1.7,0.1,2.5s0,1.5,0,2.1s-0.1,1.2-0.1,1.6 c-0.1,0.9-0.1,1.4-0.1,1.4c-0.1,1.4-1.3,2.5-2.7,2.4s-2.5-1.3-2.4-2.7c0-0.1,0-0.3,0.1-0.4v-0.2c0,0,0.1-0.5,0.3-1.2 c0.1-0.4,0.2-0.9,0.3-1.4c0.1-0.6,0.2-1.2,0.3-1.9s0.2-1.5,0.2-2.3c0-0.4,0.1-0.8,0.1-1.2c0-0.4,0-0.9,0-1.3 c0-0.9,0-1.8,0-2.7c0-0.9-0.1-1.9-0.2-2.8s-0.2-1.9-0.4-2.8c-0.1-0.5-0.2-0.9-0.2-1.4c-0.1-0.5-0.2-0.9-0.3-1.4 c-0.2-0.9-0.4-1.7-0.6-2.5c-0.2-0.8-0.5-1.6-0.7-2.3c-0.5-1.4-0.9-2.5-1.3-3.3C181.1,8.9,180.9,8.4,180.9,8.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M125.5,150.2c0,0-8.4-17.1-17.9-15c-22.6,4.9-3.7,38,9.5,39.9c4.2,0.6,7-2.7,7-2.7L125.5,150.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E87B1"
    },
    d: "M119.6,145.4c-4.8-6.6-10.7-5.2-11.5-0.4c-1.1,6.1,9,19.1,16.2,13.5L119.6,145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M109.3,140.3c-4.2-1.4-9.9,0.7-11.8,3.7c1-4.2,4-8.5,10.4-9.3c9.6-1.2,17.6,15.6,17.6,15.6 l-0.9,16.5C122.3,159.1,117.8,143,109.3,140.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M117.2,175.1c-5.4-0.8-11.7-6.8-15.8-13.9c8.6,14.4,20.1,8.3,23.2,5.6l1.4,5.2 C126,172,121.4,175.8,117.2,175.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M154.4,49.7c0.4-9.1,13.7-17,24.4-14.8s15.7,11.4,15.4,18.1C193.8,59.7,154.4,49.7,154.4,49.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E8F3"
    },
    d: "M120,177c4.6,18.1,15.8,25.9,24,35c15.7,17.6,34.2,14.6,45.6,1.4 c14.9-17.3,27.1-33.7,31.2-43.2c13.5-31.5,37.9-120.4-54.4-121.2C85.1,48.4,114.1,153.5,120,177"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#B9B9D6",
      enableBackground: "new"
    },
    d: "M219.7,83.1c-13.1,22.5-51.3,55.4-109.1,53l29.8-78.8 L219.7,83.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M211.3,77.5c0,0-0.1,0.3-0.2,0.8c-0.1,0.4-0.3,1.1-0.4,1.4c-0.1,0.2-0.1,0.4-0.2,0.6 c-0.1,0.2-0.2,0.4-0.3,0.6c-0.4,0.9-0.8,1.8-1.4,2.9c-0.6,1-1.2,2.2-2,3.4c-3,4.9-7.3,11-12.5,16.3c-1.3,1.4-2.7,2.6-4,3.9 c-0.7,0.6-1.4,1.2-2.1,1.8c-0.7,0.5-1.4,1.1-2.1,1.6s-1.4,1-2.1,1.5c-0.4,0.2-0.7,0.5-1,0.7s-0.7,0.4-1,0.6s-0.7,0.4-1,0.6 s-0.7,0.3-1,0.5s-0.7,0.3-1,0.5c-0.3,0.1-0.7,0.3-1,0.4s-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.2-0.9,0.3s-0.6,0.2-0.9,0.3 s-0.6,0.2-0.8,0.2c-0.5,0.1-1,0.3-1.5,0.4s-0.9,0.2-1.3,0.2c-0.4,0.1-0.7,0.1-1.1,0.1c-0.3,0-0.6,0.1-0.8,0.1 c-0.4,0-0.6,0.1-0.6,0.1s0.2-0.1,0.6-0.2c0.2-0.1,0.5-0.1,0.7-0.2c0.3-0.1,0.6-0.2,1-0.3s0.8-0.3,1.2-0.5s0.9-0.4,1.4-0.6 c0.2-0.1,0.5-0.2,0.7-0.4c0.2-0.1,0.5-0.3,0.8-0.4c0.3-0.2,0.5-0.3,0.8-0.5s0.5-0.4,0.8-0.5c0.3-0.2,0.6-0.4,0.8-0.6 c0.3-0.2,0.6-0.4,0.8-0.6c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.2,0.6-0.5,0.9-0.7s0.6-0.5,0.9-0.7c0.3-0.3,0.6-0.5,0.9-0.8 c0.6-0.5,1.1-1.1,1.7-1.7c0.6-0.6,1.1-1.2,1.7-1.8c0.5-0.7,1.1-1.3,1.6-2c1-1.4,2.1-2.8,3-4.2c3.9-5.8,6.9-12.2,8.7-17 c0.5-1.2,0.8-2.3,1.1-3.3s0.5-1.8,0.7-2.4c0-0.2,0.1-0.3,0.1-0.4s0-0.2,0.1-0.3c0.1-0.3,0-0.1,0-0.1l0,0v-0.1v-0.2 c0-0.1,0-0.2,0-0.2v-0.2c0.1-2.9,2.5-5.2,5.4-5.1s5.2,2.5,5.1,5.4C211.4,76.8,211.4,77.2,211.3,77.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M231.9,134.3c7-38.7,3.6-85.5-64-86.9C106,46.1,104,95.1,111.6,132 c13.8,14.8,78.2-31.4,88.1-56.3C224,93.9,230.6,126.8,231.9,134.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M149.6,115.4c-8.7,14.2-22.6,27.5-53.3,22.5c6.9-7.6,9.5-21.9,10.1-35.2L149.6,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M176.6,119.3c-0.3,1-0.9,5.3,1.4,4.7s14.6-7.5,20.6-7.6c8.5-0.2,11.4,3,13.2,2.8 s-5-4.9-8.5-6.1s-9.2-0.3-15.8,1.6C180.9,116.6,176.6,119.3,176.6,119.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M195.7,166c-2.7-0.1-2.9,4.1-0.2,4.2C198.2,170.3,198.4,166.1,195.7,166"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M190.9,157.2c-2.7-0.1-2.9,4.1-0.2,4.2C193.5,161.5,193.7,157.3,190.9,157.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M204,155c-2.7-0.1-2.9,4.1-0.2,4.2C206.5,159.3,206.7,155.1,204,155"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M143.8,169.7c-2.7-0.1-2.9,4.1-0.2,4.2C146.3,174,146.5,169.8,143.8,169.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M135.8,162.7c-2.7-0.1-2.9,4.1-0.2,4.2C138.3,167,138.5,162.8,135.8,162.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M128,153.7c-2.7-0.1-2.9,4.1-0.2,4.2C130.5,158.1,130.7,153.8,128,153.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M142.3,155.7c-2.7-0.1-2.9,4.1-0.2,4.2C144.9,160,145,155.8,142.3,155.7"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFCFE5"
    },
    d: "M159.7,137.3c0,0,1.9,15.5,1.2,19.5c-0.1,0.6,0.5,1,0.5,1c0.1,0,1.9-11.1,1.9-11.1L159.7,137.3 z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000161601276251307843210000017040610383838524830_",
    x: 80.3,
    y: 52.1,
    transform: "matrix(4.128885e-02 -0.9991 0.9991 4.128885e-02 29.0935 188.4843)",
    width: 65,
    height: 53.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101791851122189937710000013729717914997375628_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000161601276251307843210000017040610383838524830_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000101791851122189937710000013729717914997375628_)",
      fill: "#475C90"
    },
    d: "M128.9,56.2 c-9.6,8.8-26.4,23.5-32.2,53.3c0,0-2.4-16.3,9.9-34.2C114.7,63.3,128.9,56.2,128.9,56.2"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M220.7,67.1c9,11.6,19.5,52.4,36.1,59.9c0,0-19-1.3-28.2-35C221.6,66.3,220.7,67.1,220.7,67.1z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M207.9,56.6c21.3,9.6,32.1,47,45.5,50.9c0,0-14.3,1.4-25.6-24.4 C219.2,63.4,207.9,56.6,207.9,56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M94.9,33.6c-13,16.7-20.6,40-28.3,89.1s-31.2,44-37.4,44.8c0,0,25.8,10.3,41.6-22 S102.7,47,102.7,47L94.9,33.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D87B1"
    },
    d: "M179.2,138.1c0,0,0.7-6.1,5.2-9.9c6.2-5.3,14.9-2.6,18.1-0.6c3.6,2.2,3.6,4.9,3.6,4.9 s0.6,3.8-4.3,7c-2.6,1.7-7.3,3.2-10.8,2.9C187.3,142,183.6,141.1,179.2,138.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005250994912152710040000000757694119894061736_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.4224,
    y1: 231.8787,
    x2: 66.4752,
    y2: 231.8787,
    gradientTransform: "matrix(0.996 -8.943460e-02 8.943460e-02 0.996 116.79 -90.4857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    style: {
      stopColor: "#FDFCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7861,
    style: {
      stopColor: "#F6F3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ECE7E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005250994912152710040000000757694119894061736_)"
    },
    d: "M179.9,138 c1.5-2.9,5.5-8.2,13.2-7.9c7.6,0.3,10.8,5.6,10.8,5.6s-3.2,3.6-6.4,4.5C188.2,142.6,182.7,139.5,179.9,138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E87B1"
    },
    d: "M198.6,135.3c-0.3-3.7-3.9-6.4-8-6s-7.1,3.7-6.8,7.4c0.2,1.9,0.9,3.7,2.1,4.2 c3.5,0.8,7,0.8,10.1-0.2C198,139.3,198.8,137.6,198.6,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M185.8,135.3c-0.1,2.3,1.8,4.3,4.3,4.4c2.5,0.1,4.6-1.7,4.7-4.1c0.1-2.3-1.8-4.3-4.3-4.4 C188,131.2,185.9,133,185.8,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M179.9,138c0,0,2.5-6.4,12.3-6.9c7.6-0.4,11.4,4.8,12.2,4.7c3.3-0.7,3.3-4.7,3.3-5.1 c-3.5,1.7-8.7-3.4-15.1-3.1C184.7,127.9,180.1,132.8,179.9,138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9D6"
    },
    d: "M180.5,133.6c0,0,1.1-3.8,4.9-6.5c2.6-1.9,8.3-3.4,14.4-0.9c0,0-8-2.2-12.9,0.9 C182.5,129.9,180.5,133.6,180.5,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M179.9,138c0,0,3-6.2,11.6-6.7c7.1-0.3,12,4,12,4s-3.6-5.2-11.7-4.9 C186.8,130.6,182.1,132.2,179.9,138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000029747941796737049190000014698024673455529879_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M190.8,135.6 c-0.2,0.6-0.8,0.9-1.4,0.7s-0.8-0.9-0.6-1.5s0.8-0.9,1.4-0.7C190.7,134.3,191,135,190.8,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000108291787702310947200000013395058759198336668_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M194.9,136.7 c-0.3,0.8-1.1,1.2-1.9,0.9s-1.1-1.2-0.8-2s1.1-1.2,1.9-0.8C194.8,135,195.2,135.9,194.9,136.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M204.4,135.7c0.4-0.5-1.4-0.7-1.1-0.9c-2.4,3.9-6.8,5.7-10.6,6.4c3.5-0.1,6.4-1.2,9.1-3.2l0,0 c3.4,0.3,5.8-3.2,5.8-3.2C205.3,136.6,204.4,135.7,204.4,135.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D87B1"
    },
    d: "M155.1,138.1c0,0-0.7-6.1-5.2-9.9c-6.2-5.3-14.9-2.6-18.1-0.6c-3.6,2.2-3.6,4.9-3.6,4.9 s-0.6,3.8,4.3,7c2.6,1.7,7.3,3.2,10.8,2.9C147,142,150.6,141.1,155.1,138.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097485681629676006560000003000281893345098672_",
    gradientUnits: "userSpaceOnUse",
    x1: -67.0556,
    y1: 222.0483,
    x2: -43.0028,
    y2: 222.0483,
    gradientTransform: "matrix(-0.996 -8.943460e-02 -8.943460e-02 0.996 107.5907 -90.4857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4744,
    style: {
      stopColor: "#FDFCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7861,
    style: {
      stopColor: "#F6F3F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ECE7E8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097485681629676006560000003000281893345098672_)"
    },
    d: "M154.4,138 c-1.5-2.9-5.5-8.2-13.2-7.9c-7.6,0.3-10.8,5.6-10.8,5.6s3.2,3.6,6.4,4.5C146.1,142.6,151.6,139.5,154.4,138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E87B1"
    },
    d: "M135.6,135.3c0.3-3.7,3.9-6.4,8-6s7.1,3.7,6.8,7.4c-0.2,1.9-0.9,3.7-2.1,4.2 c-3.5,0.8-7,0.8-10.1-0.2C136.2,139.3,135.4,137.6,135.6,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M148.5,135.3c0.1,2.3-1.8,4.3-4.3,4.4c-2.5,0.1-4.6-1.7-4.7-4.1c-0.1-2.3,1.8-4.3,4.3-4.4 C146.3,131.2,148.4,133,148.5,135.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M154.4,138c0,0-2.5-6.4-12.3-6.9c-7.6-0.4-11.4,4.8-12.2,4.7c-3.3-0.7-3.3-4.7-3.3-5.1 c3.5,1.7,8.7-3.4,15.1-3.1C149.5,127.9,154.2,132.8,154.4,138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9D6"
    },
    d: "M153.8,133.6c0,0-1.1-3.8-4.9-6.5c-2.6-1.9-8.3-3.4-14.4-0.9c0,0,8-2.2,12.9,0.9 C151.7,129.9,153.8,133.6,153.8,133.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M154.4,138c0,0-3-6.2-11.6-6.7c-7.1-0.3-12,4-12,4s3.6-5.2,11.7-4.9 C147.5,130.6,152.1,132.2,154.4,138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M129.9,135.7c-0.4-0.5,1.4-0.7,1.1-0.9c2.4,3.9,6.8,5.7,10.6,6.4c-3.5-0.1-6.4-1.2-9.1-3.2 l0,0c-3.4,0.3-5.8-3.2-5.8-3.2C128.9,136.6,129.9,135.7,129.9,135.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M201.4,78.7c0,0-0.2,0.6-0.6,1.7c-0.2,0.5-0.5,1.4-1,2.4c-0.4,1.1-0.9,2-1.5,3.2 c-1.2,2.3-2.7,4.9-4.8,7.7c-2,2.8-4.5,5.7-7.4,8.6s-6.2,5.7-9.8,8.5s-7.5,5.4-11.5,8c-8.1,5.2-16.9,10-25.7,14.9 c-4.4,2.4-8.7,4.9-12.9,7.4c-4.2,2.5-8.2,5.1-11.9,7.7c-1.9,1.3-3.7,2.7-5.3,4.1c-0.9,0.7-1.7,1.4-2.5,2.1 c-0.8,0.7-1.6,1.4-2.3,2.2c-2.9,2.9-5.3,6.1-7,9.3c-0.2,0.4-0.4,0.8-0.6,1.2s-0.3,0.8-0.5,1.2c-0.4,0.8-0.6,1.6-0.9,2.4 c-0.1,0.4-0.2,0.8-0.3,1.2s-0.2,0.8-0.3,1.2c-0.1,0.8-0.3,1.5-0.4,2.3c-0.4,2.9-0.1,5.6,0.2,7.7c0.2,1.1,0.4,2,0.6,2.8 s0.4,1.5,0.6,2.1c0.4,1.1,0.6,1.7,0.6,1.7s-0.3-0.6-0.7-1.6c-0.3-0.5-0.5-1.2-0.8-2s-0.6-1.7-0.9-2.8c-0.5-2.1-1-4.8-1-8 c0-0.8,0.1-1.6,0.1-2.4c0-0.4,0.1-0.8,0.2-1.3c0.1-0.4,0.1-0.9,0.2-1.3c0.2-0.9,0.4-1.8,0.7-2.6c0.1-0.4,0.3-0.9,0.4-1.3 c0.2-0.4,0.3-0.9,0.5-1.4c1.5-3.6,3.7-7.3,6.5-10.7c0.7-0.9,1.4-1.7,2.2-2.6c0.8-0.8,1.5-1.7,2.4-2.5c1.6-1.7,3.3-3.3,5.1-4.9 c3.6-3.2,7.5-6.2,11.5-9.2s5.6-10.1,9.7-13c8.2-5.7,16.4-11.4,23.6-17.1c3.6-2.8,9.5-1.5,12.4-4.3c3-2.8,5.6-5.6,7.7-8.2 c2.2-2.6,3.9-5.2,5.2-7.5s2.2-4.3,2.9-6c0.3-0.8,0.6-1.6,0.8-2.2s0.3-1,0.5-1.7c0.3-1.1,0.4-1.7,0.4-1.7 c1.1-4.3,5.5-7,9.8-5.9s7,5.5,5.9,9.8C201.6,78.2,201.5,78.4,201.4,78.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001F47"
    },
    d: "M192,184.5c-0.2-0.1-1,0.2-2.3,1c-4.1,1.9-7.3,3.4-11.4,3.8c-1.3,0-18.2,0.2-19.3,0.3 c-2.6-0.1-7.6-0.9-10.6-2.1c-1.5-0.6-3.4-1.7-3.6-1.5c-0.3,0.2,0.2,2.3,2.5,2.1c5.4,0.6,7,4.4,10.2,4.6 c0.9,0.1,19.6-0.5,20.3-0.6c4.5,0,6.1-4.5,11.6-5.4C192,186.6,192,184.5,192,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#486092"
    },
    d: "M147.7,187.1c5.4,1.3,14.2,0.8,14.6,0.8c1.7,0,4.4,0.6,5.6,0.6c2.6-0.1,4.3-0.9,6.4-0.9 c0.6,0,8.4,0.4,13.5-1.2c-1.7,1.2-7.9,4.6-19.4,4.8C153.4,191.3,147.9,187.2,147.7,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D7DAE"
    },
    d: "M154.9,188.6c0.1-0.2,7.9-0.5,8.3-0.4c2.3,0.4,4.1,0.7,4.8,0.7c1.2-0.1,4.3-0.6,5.3-1 c0.4-0.1,9-0.2,8.4,0.2c-0.5,0.3-11.8,2.6-13.3,2.6C167.2,190.8,154.7,188.9,154.9,188.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#486092"
    },
    d: "M149.1,188.3c2,0.2,4.4,3.4,19.3,3.4c14-0.1,18.1-4.9,20.4-4.9c-2.5,1.2-7.2,6.3-9.4,7.8 c-1.6,1.2-5,3.6-10.5,3.9c-4.3,0.3-9.2-1.5-11.7-3.5C155.7,193.8,152.1,190,149.1,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385183"
    },
    d: "M154.6,190.7c-0.3-0.6,4.1,1.1,12.8,1.1c9,0,14.5-2.1,14.5-1.6c0,0.4-2.4,3.5-4.7,4.8 c-2.7,1.5-3.8,1.8-8.5,1.9c-3.8,0.1-7.3-0.4-9.5-1.6C156.8,194.1,155.1,191.8,154.6,190.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7E87B1"
    },
    d: "M168.9,193.4c0,0,8.8-1.6,9.1-1.1s-2.7,1.7-4.4,1.8C171.9,194.3,168,194.1,168.9,193.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000035509007214575334190000009545763255934966972_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M142.5,135.7 c0.2,0.6,0.8,0.9,1.4,0.7c0.6-0.2,0.8-0.9,0.6-1.5s-0.8-0.9-1.4-0.7C142.5,134.5,142.3,135.1,142.5,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000042702278049183948220000002675726855572300179_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.9,137.2 c0.3,0.8,1.1,1.2,1.9,0.9c0.8-0.3,1.1-1.2,0.8-2s-1.1-1.2-1.9-0.8C145.9,135.5,145.6,136.4,145.9,137.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#7E87B1",
      enableBackground: "new"
    },
    d: "M172.1,171.3c2.1-0.8,5.8-2.1,6.1-0.4 c0.2,1.4-3.3,0.9-4.8,1.3C171.8,172.7,172.1,171.3,172.1,171.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M179,166.4c0.6,1.3,1.3,5.6-1.4,6.5c0,0,2.3-0.1,2.8-2.8C181,167.3,179,166.4,179,166.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#7E87B1",
      enableBackground: "new"
    },
    d: "M163.5,171.6c-2.2-0.7-5.9-1.8-6.1,0 c-0.1,1.4,3.3,0.7,4.9,1C164,172.9,163.5,171.6,163.5,171.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B8B9D6"
    },
    d: "M156.3,167.1c-0.5,1.4-1,5.7,1.8,6.4c0,0-2.3,0.1-3-2.6C154.4,168.1,156.3,167.1,156.3,167.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#C6C8DE",
      enableBackground: "new"
    },
    d: "M163.8,172.5c0,0,1,2.1,4.2,2.1c0.1,0,0.1,0,0.2,0 c3.3-0.1,3.7-1.9,3.7-1.9c-0.9,0.6-2.2,0.8-3.5,0.8C166.7,173.5,165,173.2,163.8,172.5"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#CDCFE0",
      enableBackground: "new"
    },
    d: "M158.1,173.5c5.9,2.8,8.1,7.2,13.9,4.1s6.2-4.8,6.2-4.8 s-3.2-0.2-6.2,0.3c-1.6,0.3-3,1.5-4.1,1.4c-1.2-0.1-2-1.8-3.7-1.3C160.9,174.5,158.1,173.5,158.1,173.5z"
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000047020820442962201350000006334037606268286111_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMika);
export default __webpack_public_path__ + "static/media/mika.b7f547f8bb885b0f7e3b76074a53c2d6.svg";
export { ForwardRef as ReactComponent };